import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import VueElementLoading from 'vue-element-loading';
import {
	BasicSelect
} from 'vue-search-select';
import Multiselect from 'vue-multiselect'
import {
	Validator
} from 'vee-validate'

export default {
	name: 'push-shipment-details',
	components: {
		VueElementLoading,
		BasicSelect,
		Paginate,
		Multiselect
	},
	props: [],
	data() {
		return {
			isLoading: false,
			hubLoading: '',
			shippingID: '',
			hubid: '',
			cHubid: '',
			HubNameData: [],
			DestHubNameData: [],
			hubNameObjData: {
				value: "",
				text: ""
			},
			shipmentLimit: false,
			shipmentLimitMsg: '',
			file: '',
			filename: '',
			csvData: '',
			fileinput: ''
		}
	},
	computed: {},
	filters: {},
	mounted() {
		this.getHubName();
	},
	methods: {
		getHubName() {
			this.hubLoading = 'Loading Hub...'
			var i = 0;
			axios({
				method: 'POST',
				'url': apiUrl.api_url_hubops + 'hubservicecenter/list',
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
				.then(result => {
					this.hubLoading = ''
					var HubNameData = result.data.ResponseData
					for (i = 0; i < HubNameData.length; i++) {
						this.DestHubNameData.push({
							value: HubNameData[i].HubID,
							text: HubNameData[i].HubName + ' (' + HubNameData[i].HubID + ')'
						})
						this.HubNameData = this.DestHubNameData
					}
				}, error => {
					console.error(error)
				})
		},
		selectedHub(hubNameObjData) {
			this.hubNameObjData = hubNameObjData;
			this.hubid = hubNameObjData.value;
		},
		clearID() {
			this.isLoading = false
			this.hubLoading = ''
			this.shippingID = ''
			this.shipmentLimit = false
			this.shipmentLimitMsg = ''
			this.hubid = ''
			this.cHubid = '';
			this.hubNameObjData = []
			this.file = null
			this.filename = ''
			this.csvData = ''
			this.$validator.reset();
		},
		onSubmit: function (event) {
			this.$validator.validateAll().then((result) => {
				if (!result) {
					return false;
				} else if (!this.csvData && this.shippingID.length < 1) {
					this.filename = 'Choose file to upload.';
					this.shipmentLimit = true
					this.shipmentLimitMsg = 'The shippingID field is required.';
					return false;
				}
				else {
					this.filename = '';
					this.shipmentLimit = false
					this.shipmentLimitMsg = '';
					this.PushShipmentDetails()
				}
			}).catch((errors) => {
				console.log('errors exist', errors)
			});
		},
		PushShipmentDetails() {
			this.shipmentLimit = false;
			this.shipmentLimitMsg = '';
			let inputArray = '';
			this.isLoading = true;
			let shipmentArray = [];
			if (this.shippingID) {
				if (/\r?\n|\r/g.test(this.shippingID) == true) {
					this.shippingID = this.shippingID.replace(/\r?\n|\r/g, ',');
				}
				if (/\s/g.test(this.shippingID) == true) {
					this.shippingID = this.shippingID.replace(/\n|"|'| |,\s*$/g, '');
				}
				if (this.shippingID.indexOf(',') == -1) {
					shipmentArray.push(this.shippingID);
				} else {
					shipmentArray = this.shippingID.split(',');
				}
				if (shipmentArray.length > 50000) {
					this.isLoading = false
					this.shipmentLimit = true
					this.shipmentLimitMsg = "Please enter shipment's quantity upto 50,000"
					return false;
				}
				for (let i = 0; i < shipmentArray.length; i++) {
					if (shipmentArray[i].length > 0) {
						if (inputArray == '' || inputArray.length < 1)
							inputArray = shipmentArray[i]
						else
							inputArray = inputArray + ',' + shipmentArray[i]
					}
				}
			} else if(this.csvData && this.csvData.length>1){
				inputArray = this.csvData;
			} else {
				this.$alertify.error("Please provide appropriate input.");
				return;
			}
			this.input = ({
				SorterLocation: this.hubid,
				ShipmentList: inputArray
			})
			axios({
				method: 'POST',
				url: apiUrl.api_url_hubops + 'pushShipmentDetails',
				data: this.input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			}).then(result => {
				this.isLoading = false;
				if (result.data.ResultCode == 100) {
					this.$alertify.success(result.data.ReturnMessage)
					this.clearID()
				} else {
					this.$alertify.error(result.data.ReturnMessage)
				}
			}, error => {
				console.error(error)
				this.isLoading = false
			})
		},
		handleFileUpload(event) {
			this.file = event.target.files[0];
			this.filename = this.file.name;
			var parts = this.filename.split('.');
			if (parts[1].toLowerCase() !== "csv") {
				this.$alertify.error("Please select CSV file");
				return false;
			}
			this.shipmentLimit = false
			this.shipmentLimitMsg = '';
			this.createInput();
		},
		createInput() {
			var reader = new FileReader();
			var vm = this;
			reader.onload = (e) => {
				vm.fileinput = reader.result;
				this.csvData = vm.fileinput.replace(/\n/g, ",");
				this.csvData = this.csvData.slice(11, this.csvData.length - 1)
			}
			reader.readAsText(this.file);
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/PushShipmentDetails/PushShipmentDetails.js